import { Component, Input } from '@angular/core';
import { DesignBlockBaseViewComponent, DesignBlockImageScope, DesignBlockScope, WebsitePageScope } from '@sb/library/base';
import { WebsiteBlockTextAndMediaDisplayItem, WebsiteBlockTextAndMediaImageDisplayItem, WebsiteBlockTextAndMediaType } from '@sb/library/data-models';

@Component({
    selector: 'lib-hero-design-block',
    templateUrl: './hero-design-block.component.html',
    styleUrls: ['./hero-design-block.component.scss']
})
export class HeroDesignBlockComponent extends DesignBlockBaseViewComponent implements DesignBlockScope, DesignBlockImageScope {

    override Scope = this.SetScope({
        Implements: [DesignBlockScope, DesignBlockImageScope],
        Requires: WebsitePageScope
    });

    @Input() websiteBlockData!: WebsiteBlockTextAndMediaDisplayItem;

    get hasHeader(): boolean {
        return this.websiteBlockData.Header !== null;
    }

    get hasBody(): boolean {
        return this.websiteBlockData.Body !== null;
    }

    get kind(): WebsiteBlockTextAndMediaType {
        return this.websiteBlockData.TextAndMediaType;
    }

    get imageData(): WebsiteBlockTextAndMediaImageDisplayItem {
        return this.websiteBlockData.Images[0];
    }
}
